<template>
  <nav>
     <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row
      v-if="!error"
      align="center"
    >
      <v-col
        cols="12"
        sm="12"
        md="12"
        align="center"
        class="py-0"
      >
        <v-row>
          <v-toolbar
            v-if="!loadingData"
            class="py-0"
            :style="{ 'background-image': 'url(' + coverImage + ')' , 'background-repeat': 'no-repeat', 'background-size' : 'cover','background-position':' center center' }"
            :height="!mobile() ? '330px' : '100px'"
          >
            <v-col
              cols="12"
              sm="6"
              md="6"
              :class="!mobile() ? 'ma-auto px-3' : 'd-flex justify-end ma-auto'" 
            >   
              <v-autocomplete
                v-model="select"
                :menu-props="{
                  closeOnContentClick:true,
                  rounded: 'xxl',
                  zIndex: '0 !important',
                }"
                filled
                rounded
                deletable-chips
                clearable
                solo
                no-filter
                :hide-no-data="mobile()"
                :search-input.sync="searchKeyword"
                :items="searchItem" 
                item-text="title"
                item-value="title" 
                :placeholder="`${!mobile() ? $t('hubSearchPlaceholder') : ''} ${(mobile() && !searchClosed) ? $t('hubSearchPlaceholder') : ''}`" 
                append-icon="mdi-magnify"
                background-color="#fff"
                data-testid="search-category"
                class="expanding-search hub-items-search"
                :class="`${(mobile() && searchClosed) ? 'closed' : ''} ${mobile() ? 'mt-1' : 'px-0'}`"
                :style="mobile() ? 'z-index:7' : ''"
                @focus="searchClosed = false"
                @blur="closeSearch"
              >
              <template v-slot:no-data>
                  <p class="mx-8 mt-4">
                    {{ $t('noDataText') }}
                  </p>
                </template>

                <template v-slot:selection="{ attr, on, item, selected }">  
                  <v-chip
                    v-bind="attr"
                    :input-value="selected"
                    color="accent"
                    class="white--text"
                    width="100"
                    v-on="on"
                  >
                    <span v-text="item.attributes.title" />
                  </v-chip>
                </template>
                <template
                  v-slot:item="data"
                  data-testid="suggested-item"
                >
                  <template v-if="(typeof data.item) !== 'object'">
                    <v-list-item-content v-text="data.item" />
                  </template>
                  <template v-else>
                    <v-img
                      v-if="data.item.attributes.entity_type == 'hub_activities'"
                      :src="(data.item.attributes.image) ? data.item.attributes.image: require('../../assets/cover-activity.jpg')"
                      class="ma-2 rounded-lg"
                      style="object-fit: cover;width: 50px;height: 40px;border: 1px solid var(--v-greylightBorder-base,0.7);"
                      @click="proceedClick(data.item)"
                    />
                    <v-img
                      v-if="data.item.attributes.entity_type == 'hub_attachments' && attachmentIcons[attachmentIcons.findIndex(itemIcon => itemIcon.type == data.item.attributes.attachment_ext)]"
                      class="ma-2 rounded-lg item-list-view"
                      :style="`background: `+attachmentIcons[attachmentIcons.findIndex(itemIcon => itemIcon.type == data.item.attributes.attachment_ext)].background"
                      style="object-fit: cover;width: 50px;height: 40px;"
                       @click="proceedClick(data.item)"
                    >
                      <v-icon
                        size="24px"
                        class=""
                      >
                        mdi-tray-arrow-down
                      </v-icon>
                    </v-img>
                    <v-img
                      v-if="data.item.attributes.entity_type == 'hub_links'"
                      class="ma-2 rounded-lg item-list-view"
                      style="object-fit: cover;width: 50px;height: 40px;background: #D2DEFD"
                       @click="proceedClick(data.item)"
                    >
                      <v-icon
                        size="24px"
                        class=""
                      >
                        mdi-open-in-new
                      </v-icon>
                    </v-img>
                    <a
                      style="width:100%"
                      @click="proceedClick(data.item)"
                    ><v-list-item-content>
                      <v-list-item-title> {{ data.item.attributes.title }} </v-list-item-title>
                    </v-list-item-content></a>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
          </v-toolbar>
        </v-row>
      </v-col>
    </v-row>    
  <v-row>
     <v-col cols="10">
      <v-breadcrumbs class="mx-4 font-weight-medium" >
        <v-breadcrumbs-item
          active-class
        :to="{ path: '/hub/' + hubID}"
        >
          {{ hubTitle }}
        </v-breadcrumbs-item >
        <v-icon>mdi-chevron-right</v-icon>
        <v-breadcrumbs-item
          disabled
        >
          {{ categoryTitle }}
        </v-breadcrumbs-item>
      </v-breadcrumbs>
     </v-col>
     <v-col cols="2" v-if="categoryItems.length > 1 && roleHub == 'booster' && !mobile()">
      <v-btn
          class="rounded-lg text-none px-2 mb-2 mb-md-0 my-3 mx-3 float-right"
          min-width="38"
          @click.stop="
            dialogVisibleReorderHubItems = true;
            confirmationDialogTitle = $t(
              'confirmationDialogReorderCategoryItemsTitle'
            );
            confirmationDialogDescription = $t(
              'confirmationDialogReorderCategoryDescription'
            );
          "
          data-testid="reorder-button"
        >
          <v-icon >
            mdi-swap-vertical
          </v-icon>
        </v-btn>
     </v-col>
    </v-row>

    <!-- description -->
    <v-row v-if="!mobile()">
      <v-col 
        cols="12"
        sm="12"
        md="6"
        class="d-flex justify-center align-center px-10 mx-auto pt-0"
      >
        <p class="d-flex justify-center text-body-1 greytext--text text-center">
          {{ description }}
        </p>
      </v-col>
    </v-row>

    <v-row v-else class="mb-6">
      <v-col
        v-if="!readMore && description && description.length > 220"
        cols="12"
        sm="12"
        md="6"
        class="d-flex justify-center align-center px-10 mx-auto pt-0"
      >
        <p class="d-flex justify-center text-body-1 greytext--text text-center">
          {{ description ? description.substring(0, 220) + "..." : '' }}
        </p>
      </v-col>

      <v-col
        v-if="readMore || (description && description.length < 220)"
        cols="12"
        sm="12"
        md="6"
        class="d-flex justify-center align-center px-10 mx-auto pt-0"
      >
        <p class="d-flex justify-center text-body-1 greytext--text text-center">
          {{ description }}
        </p>
      </v-col>

      <a
        v-if="!readMore && description && description.length > 220"
        class="text-caption mx-auto mt-n6"
        data-testid="read-more"
        @click="showMore()"
      >{{ $t('readMore') }}</a>
      <a
        v-if="readMore"
        class="text-caption mx-auto mt-n6"
        data-testid="read-less"
        @click="showLess()"
      >{{ $t('readLess') }}</a>
    </v-row>

    <v-row>
      <v-col
        data-testid="list-mode"
        cols="10"
        class="mx-auto"
      >
        <v-row
          v-for="item in categoryItems"
          :key="item.id"
          align="center"
          cols="12"
          class="mb-2 pa-0"
        >
          <v-col
            cols="12"
            class="pa-0"
          >  
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                :height="!mobile() ? '87' : '57'"
                rounded="xxl" 
                class="mx-auto rounded-xxl"
                :ripple="false"
                :class="`elevation-${hover? 8 : 2 } ${hover? 'v-card--shadow': 'v-card--flat'}`" 
                @click="item.attributes.entity_type != 'hub_activities' ? proceedClick(item) : ''"
                :to="item.attributes.entity_type == 'hub_activities' && (item.attributes.role != 'NA' || item.attributes.sharing_setting != 'Restricted') ? '/activity/'+item.attributes.entity_id : ''"
              >
                <v-row no-gutters>
                  <v-col
                    v-if="item.attributes.entity_type == 'hub_activities'"
                    :cols="!mobile() ? '2' : '4'"
                    class="pa-0"
                  >
                    <v-responsive>
                      <v-img
                        style="border: 1px solid var(--v-greylightBorder-base,0.7);"
                        width="75%"
                        class="rounded-xxl"
                        :src="(item.attributes.image) ? item.attributes.image : require('../../assets/cover-activity.jpg')"
                        :height="!mobile() ? '88px' : '58px'"
                      />
                    </v-responsive>
                  </v-col>
                  <v-col
                    v-else-if="item.attributes.entity_type == 'hub_attachments'"
                    :cols="!mobile() ? '2' : '4'"
                    class="pa-0"
                  >
                    <v-responsive v-if="attachmentIcons[attachmentIcons.findIndex(itemIcon => itemIcon.type == item.attributes.attachment_ext)]">                      
                      <v-img
                        :style="`background: `+attachmentIcons[attachmentIcons.findIndex(itemIcon => itemIcon.type == item.attributes.attachment_ext)].background"
                        width="75%"
                        class="rounded-xxl item-list-view"
                        :height="!mobile() ? '88px' : '58px'"
                      >
                      <v-icon
                        x-large
                        class="pr-1"
                      >
                        mdi-tray-arrow-down
                      </v-icon>
                      </v-img>
                    </v-responsive>
                  </v-col>
                  <v-col
                    v-else
                    :cols="!mobile() ? '2' : '4'"
                    class="pa-0"
                  >
                    <v-responsive >                      
                      <v-img
                        style="background: #D2DEFD"
                        width="75%"
                        class="rounded-xxl item-list-view"
                        :height="!mobile() ? '88px' : '58px'"
                      >
                      <v-icon
                        x-large
                        class="pr-1"
                      >
                        mdi-open-in-new
                      </v-icon>
                      </v-img>
                    </v-responsive>
                  </v-col>
                  <v-col
                    :cols="!mobile() ? '4' : '7'" 
                    xl="4"
                    align-self="center"
                    class="pa-0"
                    :class="!mobile() ? 'ml-n7' : 'ml-n2'"
                  >
                      <v-card-title class="text-left pa-0 no-break d-flex d-block ">
                        <span v-if="item.attributes.entity_type == 'hub_attachments' && attachmentIcons[attachmentIcons.findIndex(itemIcon => itemIcon.type == item.attributes.attachment_ext)]"
                            :style="`color: `+attachmentIcons[attachmentIcons.findIndex(itemIcon => itemIcon.type == item.attributes.attachment_ext)].color"
                            :class="`mdi mdi-24px `+attachmentIcons[attachmentIcons.findIndex(itemIcon => itemIcon.type == item.attributes.attachment_ext)].icon"
                            style="float:left">&nbsp;</span>
                        <span v-if="item.attributes.entity_type == 'hub_links'"
                            class="mdi mdi-web accent--text"
                            :class="!mobile() ? 'mdi-24px' : 'mdi-16px'"
                            style="float:left">&nbsp;</span>
                        <v-clamp
                          autoresize
                          :max-lines="1"
                          :class="mobile() ? 'text-body-1' : ''"
                        >
                          {{ item.attributes.title }}
                      </v-clamp>
                      </v-card-title>
                  </v-col>
                    <v-col
                    v-if="!mobile()"
                    cols="3"
                    xl="3"
                    align-self="center"
                    class="pa-0 ml-6"
                  >
                      <v-card-subtitle class="text-caption text-left pa-0 no-break" v-if="item.attributes.entity_type == 'hub_attachments'">
                        <v-clamp
                          autoresize
                          :max-lines="1"
                        >
                          {{ item.attributes.attachment_title }}
                        </v-clamp>
                      </v-card-subtitle>
                      <v-card-subtitle class="text-caption text-left pa-0 no-break" v-if="item.attributes.entity_type == 'hub_links'">
                        <v-clamp
                          autoresize
                          :max-lines="1"
                          class="accent--text"
                        >
                          {{ item.attributes.url }}
                        </v-clamp>
                      </v-card-subtitle>
                  </v-col>
                 
                  <v-col
                    v-if="item.attributes.entity_type == 'hub_activities'  && !mobile()"
                    cols="2"
                    xl="2"
                    align-self="center"
                    class="text-right d-flex align-center justify-end pa-0 ml-n3"
                  >
                    <v-card-text
                      class="pa-0"
                    >
                      <v-tooltip bottom v-if="(item.attributes.sharing_setting && (roleHub == 'booster' || roleHub == 'NA') && item.attributes.sharing_setting == 'Restricted') || (roleHub != 'booster' && roleHub != 'NA' && item.attributes.sharing_setting == 'Restricted' && item.attributes.role == 'NA')">
                        <template v-slot:activator="{ on }">
                          <v-chip
                            small
                            data-testid="sharing-setting-chip"
                            color="darktext"
                            text-color="white"
                            filter-icon="mdi-equalizer-outline"
                            v-on="on"
                            class="mr-2"
                          >
                            <v-icon
                              size="14"
                              class="pr-1"
                            >
                              mdi-share-variant
                            </v-icon>
                            <span>{{ $t('sharingSettingRestricted') }}</span>
                          </v-chip>
                        </template>
                        <span>{{ $t('sharingSettingRestrictedTooltipHubs') }}</span>
                      </v-tooltip>
                      <div style="width: 24px; height: 24px; float: right;">
                        <v-tooltip bottom v-if="roleHub == 'booster' && item.attributes.auto_share == true">
                          <template v-slot:activator="{ on }">
                            <v-icon
                              data-testid="auto-sharing-icon"
                              color="warning"
                              text-color="white"
                              v-on="on"
                            >
                              mdi-alpha-a-circle
                            </v-icon>
                          </template>
                          <span>{{ $t('activityAutoshareTooltipHubs') }}</span>
                        </v-tooltip>
                      </div>
                    </v-card-text>
                  </v-col> 
                  <v-col cols="2"
                    xl="2" align-self="center"
                    class=" pa-0 ml-n3" v-else>
                  </v-col>
                  <v-col
                    v-if="!mobile()"
                    align-self="center"
                    cols="1"
                    class="text-right d-flex align-center justify-end three-dots  py-2"
                  >
                    <v-card-actions class="px-0">
                      <v-menu
                        v-if="roleHub == 'booster'"
                      >
                        <template v-slot:activator="{  on: { click }, attrs }">
                          <v-btn
                            icon
                            v-bind="attrs"
                            v-on:click.stop.prevent="click"
                          >
                            <v-icon
                              large
                              class="darktext--text"
                              data-testid="threedots-icon"
                            >
                              mdi-dots-vertical
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list
                          data-testid="menu-list-activity"
                          class="pa-0"
                        >
                          <v-list-item
                            v-if="
                              roleHub == 'booster' &&
                              item.attributes.role == 'booster' &&
                              sharingSetting == 1
                            "
                            data-testid="autosharing-activity-item"
                            router
                            @click.stop="
                              (selectedActivity = item),
                                (dialogVisibleChangeActivityAutosharing = true),
                                (confirmationDialogTitle = $t(
                                  'confirmationDialogTitleActivityAutosharing'
                                )),
                                (confirmationDialogSubmitBtn = $t('save'));
                              confirmationDialogCancelBtn = $t('cancel');
                            "
                          >
                            <v-list-item-title>{{
                              $t("autosharing")
                            }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            v-if="
                              item.attributes.entity_type == 'hub_attachments'
                            "
                            data-testid="edit-attachment-item"
                            router
                            @click.stop="
                              selectedItem = item;
                              dialogVisibleAddAttachment = true;
                            "
                          >
                            <v-list-item-title>
                              {{ $t("edit") }}
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            v-if="item.attributes.entity_type == 'hub_links'"
                            data-testid="edit-link-item"
                            router
                            @click.stop="
                              selectedItem = item;
                              dialogVisibleAddLink = true;
                            "
                          >
                            <v-list-item-title>
                              {{ $t("edit") }}
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            data-testid="change-category-item"
                            router
                            @click.stop="
                              selectedItem = item;
                              dialogVisibleChangeCategory = true;
                              (confirmationDialogTitle = $t(
                                'confirmationDialogTitleChangeCategory'
                              )),
                                (confirmationDialogSubmitBtn = $t('save'));
                              confirmationDialogCancelBtn = $t('cancel');
                            "
                          >
                            <v-list-item-title>
                              {{ $t("moveItem") }}
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            v-if="
                              item.attributes.entity_type == 'hub_activities'
                            "
                            data-testid="delete-activity-item"
                            router
                            @click="
                              deleteHubActivity(item.attributes.entity_id)
                            "
                          >
                            <v-list-item-title>
                              {{ $t("remove") }}
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            v-else-if="
                              item.attributes.entity_type == 'hub_attachments'
                            "
                            data-testid="delete-attachment-item"
                            router
                            @click="
                              deleteHubAttachment(item.attributes.entity_id)
                            "
                          >
                            <v-list-item-title>
                              {{ $t("remove") }}
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            v-else
                            data-testid="delete-link-item"
                            router
                            @click="deleteHubLink(item.attributes.entity_id)"
                          >
                            <v-list-item-title>
                              {{ $t("remove") }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-card-actions>
                  </v-col>
                  <v-col
                    cols="2"
                    xl="2"
                    align-self="center"
                    class="pa-0 ml-n3"
                    v-else
                  >
                  </v-col>
                </v-row>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
     <!-- Pagination -->

    <Pagination
      v-model="pageNumber"
      ref="pagination"
      class="mb-16"
      circle
      :data-length="categoryItemsInfo.total"
      :page-number="categoryItemsInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
      :key="updateNavigation"
    />
        <ConfirmationDialogChangeActivityAutosharing
      v-if="dialogVisibleChangeActivityAutosharing"
      ref="confirmationDialogActivityAutosharing"
      :visible="dialogVisibleChangeActivityAutosharing"
      :cd-title="confirmationDialogTitle"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      :loading="loadingUpdateAutosharing"
      :activity-auto-share="selectedActivity.attributes.auto_share"
      data-testid="confirmation-dialog-change-activity-auto-sharing"
      @close="dialogVisibleChangeActivityAutosharing = false"
      @proceedSubmit="changeActivityAutoSharing"
    />
      <ConfirmationDialogInputAndFile
      v-if="dialogVisibleAddAttachment"
      :visible="dialogVisibleAddAttachment"
      data-testid="add-file"
      :cd-submit-btn="confirmationDialogInputAndFileSubmitBtn"
      :cd-input-placeholder="confirmationDialogInputAndFileInputPlaceholder"
      @close="dialogVisibleAddAttachment = false"
      :cd-title="confirmationDialogInputAndFileTitle"
      :item="selectedItem"
      @proceedSubmit="reloadFiles"
    />
    <ConfirmationDialogInputAndLink
      v-if="dialogVisibleAddLink"
      :visible="dialogVisibleAddLink"
      data-testid="add-file"
      :cd-submit-btn="confirmationDialogInputAndLinkSubmitBtn"
      :cd-input-placeholder="confirmationDialogInputAndLinkInputPlaceholder"
      @close="dialogVisibleAddLink = false"
      :cd-title="confirmationDialogInputAndLinkTitle"
      :item="selectedItem"
      @proceedSubmit="reloadFiles"
    />
    <ConfirmationDialogChangeCategory
      v-if="dialogVisibleChangeCategory"
      :visible="dialogVisibleChangeCategory"
      data-testid="change-category"
      :cd-title="confirmationDialogTitle"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      @close="dialogVisibleChangeCategory = false"
      @proceedSubmit="changeCategory"
      :loading="loadingChangeCategory"
      :item="selectedItem"
      :items="hubCategories"
    />
      <ConfirmationDialogReorderHubItems
      v-if="dialogVisibleReorderHubItems"
      :visible="dialogVisibleReorderHubItems"
      data-testid="reorder-hub-items"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      :cd-title="confirmationDialogTitle"
      :cd-description="confirmationDialogDescription"
      @close="reloadCategory"
      @proceedSubmit="reloadItems"
      :items-category="allCategoryItems"
    />
  </nav>
  
</template>

<script>
import i18n from '../../plugins/i18n'
import VClamp from 'vue-clamp'
import {eventBus} from '../../eventbus'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'
import Pagination from "../../components/Pagination"
import { getHub,searchItemsHub,getHubCategory,getCategoryItems,changeHubItemCategory,getHubCategories,getAllCategoryItems,deleteHubActivity,  deleteHubAttachment,
deleteHubLink,updateHubActivityRelationship, } from '../../api/hubApi'
import ConfirmationDialogChangeActivityAutosharing from "../../components/ConfirmationDialogChangeActivityAutosharing";
import ConfirmationDialogChangeCategory from "../../components/ConfirmationDialogChangeCategory";
import ConfirmationDialogReorderHubItems from "../../components/ConfirmationDialogReorderHubItems";
import ConfirmationDialogInputAndFile from "../../components/ConfirmationDialogInputAndFile";
import ConfirmationDialogInputAndLink from "../../components/ConfirmationDialogInputAndLink";
export default {
components: {
        VClamp,
        AlertMessages,
        ConfirmationDialogChangeCategory,
        Pagination,
        ConfirmationDialogReorderHubItems,
        ConfirmationDialogInputAndFile,
        ConfirmationDialogInputAndLink,
        ConfirmationDialogChangeActivityAutosharing
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            isAuth: window.$cookies.get("token")? true: false,
            select: null,
            searchKeyword:null,
            searchItem:[],
            isLoading: false,
            valid: true,
            error: false,
            categoryTitle: '',
            hubTitle:'',
            description:'',
            alertMsg: '',
            alertType:'',
            alertValue:false,
            buttonDisabled: false,
            coverImageData: null,
            coverURL: require('../../assets/background-hub.jpg'),
            coverPath: null,
            coverImage: null,
            loadingData: false,
            spaceId: window.$cookies.get('space_id'),
            space: window.location.host.split('.')[0],
            searchTerm: "",
            label: "Use quick search to find the right resources!",
            hubID: this.$route.params.id,
            categoryId: this.$route.params.categoryId,
            showCreatedAlert: this.$route.params.successfullyCreatedHub,
            isMobile: false,
            link: {title: '', route: '/hub/'+this.$route.params.id+'/add-activities'},
            categoryItems: [],
            pageNumber: 1,
            size: 12,
            categoryItemsInfo: { 
                currentPage: 1,
                total: 0,
            },
            role: localStorage.space ? JSON.parse(localStorage.space).role : '',
            roleHub:'',
            subscriptionEnds: localStorage.space ? JSON.parse(localStorage.space).subscription_ends_at: '',
            autoShareWithActivities: false,
            dialogVisibleChangeActivityAutosharing: false,
            selectedActivity: '',
            loadingUpdateAutosharing: false,
            sharingSetting: '',
            dialogVisibleCreateContentTemplate:false,
            attachmentIcons: [
                {background: '#C9F3DB',type: 'jpeg', color: '#00C853', icon: 'mdi-file-jpg-box'},					
                {background: '#C9F3DB',type: 'jpg', color: '#00C853', icon: 'mdi-file-jpg-box'},					
                {background: '#D2DEFD',type: 'png', color: '#2962FF', icon: 'mdi-file-png-box'},					
                {background: '#FFCED7',type: 'pdf', color: '#ff1744', icon: 'mdi-file-pdf-box'},					
                {background: '#FEF2D3',type: 'ppt', color: '#FBC02D', icon: 'mdi-file-powerpoint-outline'},					
                {background: '#FEF2D3',type: 'pptx', color: '#FBC02D', icon: 'mdi-file-powerpoint-outline'},					
                {background: '#D2DEFD',type: 'doc', color: '#2979FF', icon: 'mdi-file-document-outline'},					
                {background: '#D2DEFD',type: 'docx', color: '#2979FF', icon: 'mdi-file-document-outline'},					
                {background: '#C9F3DB',type: 'xls', color: '#00C853', icon: 'mdi-file-excel-outline'},					
                {background: '#C9F3DB',type: 'xlsx', color: '#00C853', icon: 'mdi-file-excel-outline'},					
                {background: '#D2DEFD',type: 'odt', color: '#2979FF', icon: 'mdi-file-document-outline'},					
                {background: '#C9F3DB',type: 'csv', color: '#00C853', icon: 'mdi-file-delimited-outline'},					
                {background: '#C9F3DB',type: 'ods', color: '#00C853', icon: 'mdi-file-excel-outline'},					
                {background: '#E3E3E3',type: 'rtf', color: '#7C8386', icon: 'mdi-file-document-outline'},					
                {background: '#E3E3E3',type: 'txt', color: '#7C8386', icon: 'mdi-file-document-outline'}
            ],
            selectedItem: {},
            dialogVisibleAddAttachment: false,
            confirmationDialogInputAndFileTitle: i18n.t('attachFile'), 
            confirmationDialogInputAndFileSubmitBtn: i18n.t("save"),
            confirmationDialogInputAndFileInputPlaceholder: i18n.t("inputText"),
            dialogVisibleAddLink: false,
            confirmationDialogInputAndLinkTitle: i18n.t('attachLink'), 
            confirmationDialogInputAndLinkSubmitBtn: i18n.t("save"),
            confirmationDialogInputAndLinkInputPlaceholder: i18n.t("inputText"),
            updateNavigation: null,
            dialogVisibleHubCategory: false,
            confirmationDialogHubCategoryTitle: i18n.t('confirmationDialogCreateHubCategoryTitle'),
            hubCategories: [],
            dialogVisibleRemoveCategory: false,
            confirmationDialogTitle: "",
            confirmationDialogDescription:"",
            confirmationDialogText: "",
            confirmationDialogCancelBtn: "",
            confirmationDialogSubmitBtn: "",
            selectedCategoryItem: {},
            dialogVisibleChangeCategory: "",
            loadingChangeCategory: false,
            dialogVisibleReorderHubItems:false,
            allHubItems: [],
            searchClosed: true,
            readMore: false
        }
    },
    computed:{
      productPlan() {
        return this.$store.state.productPlan;
      },
    },
    watch: {
        searchKeyword(val) {
            if (val == null || val == '') {
                this.searchItem = []
                return
            }
            let searchkey = val.trim()
            if (searchkey.length < 2) return
            this.isLoading = true
            this.searchItems(searchkey)
        },
    },
    beforeDestroy () {
      if (typeof window === 'undefined') return

      window.removeEventListener('resize', this.onResize, { passive: true })
      eventBus.$off('setHubDescription')
      eventBus.$off('setHubImage')
      eventBus.$off('setSharingSettings')
    },
    beforeRouteEnter(to, from, next) {
         next(vm => {
            vm.getPrevRoute(from)
        })
    },

    async created(){
        eventBus.$on('setHubDescription',(data)=>{
            this.description = data
        })
        eventBus.$on('setHubImage',(data)=>{
          if(data == null){
            this.coverImage = this.coverURL
          }else{
            this.coverImage = data
          }
        })

        eventBus.$on('setSharingSettings',(settings)=>{
            this.sharingSetting = settings
        })

        this.loadingData = true
        await this.getHub()
        await this.getHubCategory()
        await this.getCategoryItems()
        await this.getHubCategories();
        this.loadingData = false
        await this.getAllCategoryItems();
    },
    mounted () {
      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })
    },
    methods:{
        async searchItems(keyword){
            try {
                const response = await searchItemsHub(this.hubID,keyword)
                if(response){
                    if(response.status == 200){
                        this.searchItem = response.data.data
                    }
                }
            } catch (e) {
                if(e.response){
                    this.error = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                    this.alertValue = true
                } 
            }
            finally {this.isLoading = false }
        },
        async reloadCategory(){
          //this.loadingData = true;
          this.dialogVisibleReorderHubItems = false
          await this.getCategoryItems()
          await this.getAllCategoryItems();
          //this.loadingData = false;
        },
        async reloadItems(){
          await this.getCategoryItems()
          await this.getAllCategoryItems();
        },
        showActivityDetail(id) {
          this.$router.push({ path: "/activity/" + id });
        },
        showCategoryDetail(id){
            this.$router.push({path: '/hub/' + this.hubID + '/category/'+id })
        },
        getPrevRoute(data){
            if(data.name == 'Hubs' || data.name == 'SharedWithMeHubs' ||  data.name == 'Dashboard' || data.name == 'AllActivitiesParticipant' || data.name == 'AllHubsParticipant' ||  data.name == 'ActivitiesParticipant'){
                eventBus.$emit('setHubExitBtn',data)
            }
        },
        handlePageChange(value) {
          this.categoryItemsInfo.currentPage = value;
          this.pageNumber = value;
          this.getCategoryItems();
        },
        onResize () {
            this.isMobile = window.innerWidth < 600
        },
        async reloadFiles(action) {
          if (action == "add-link") {
            this.pageNumber = 1;
            this.categoryItemsInfo.currentPage = 1;
            this.getCategoryItems();

            this.updateNavigation = Date.now();

            this.alertType = "success";
            this.alertMsg = i18n.t("addLinkHubSuccess");
            this.alertValue = true;
          } else if (action == "add-file") {
            this.pageNumber = 1;
            this.categoryItemsInfo.currentPage = 1;
            this.getCategoryItems();

            this.updateNavigation = Date.now();

            this.alertType = "success";
            this.alertMsg = i18n.t("addFileHubSuccess");
            this.alertValue = true;
          } else {
            this.getCategoryItems();
          }
        },
        downloadData(item) {
          const anchor = document.createElement("a");
          anchor.href = item.attachment_url;
          anchor.target = "_blank";
          anchor.download = item.attachment_title;
          anchor.click();
        },
        proceedClick(item){
          if(item.attributes.entity_type == 'hub_activities'){
            if(item.attributes.role != 'NA' || item.attributes.sharing_setting != 'Restricted'){
              this.showActivityDetail(item.attributes.entity_id)
            }
          }else if(item.attributes.entity_type == 'hub_attachments') {
            this.downloadData(item.attributes)
          }else{
            window.open(item.attributes.url,'_blank'); 
          }
        },
        async getHub(){
            try {
                const response = await getHub(this.hubID)
                if(response){
                    if(response.status == 200) {
                        this.hubTitle = response.data.data.attributes.title
                        this.description =  response.data.data.attributes.description
                        this.coverImage = response.data.data.attributes.image ? response.data.data.attributes.image : this.coverURL
                        this.roleHub = response.data.data.attributes.role
                        this.autoShareWithActivities = response.data.data.attributes.auto_share_with_activities
                        this.sharingSetting = response.data.data.relationships['sharing-setting'].data.id
                        //eventBus.$emit('setHubTitle',this.title)
                    }
                }
            } catch (e) {
                if(e.response){
                    if (e.response.status == 401) {
                        this.$router.push({name: 'ErrorPageHub', query: {referer: this.$route.fullPath}})
                    }else if(e.response.status == 404) {
                         this.$router.push({name: 'PageNotFound'})
                    }else if(e.response.status == 403){
                      this.$router.push({name: 'ErrorPageHub', query: {referer: this.$route.fullPath}})
                    }else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                        this.alertValue = true
                    }
                } 
            }
        },
        async getHubCategory(){
            try {
                const response = await getHubCategory(this.categoryId)
                if(response){
                    if(response.status == 200) {
                        this.categoryTitle = response.data.data.attributes.title
                        this.description =  response.data.data.attributes.description
                        eventBus.$emit('setHubCategoryTitle',this.categoryTitle)
                    }
                }
            } catch (e) {
                if(e.response){
                    if (e.response.status == 401) {
                        this.$router.push({name: 'ErrorPageHub', query: {referer: this.$route.fullPath}})
                    }else if(e.response.status == 404) {
                         this.$router.push({name: 'PageNotFound'})
                    }else if(e.response.status == 403){
                      this.$router.push({name: 'ErrorPageHub', query: {referer: this.$route.fullPath}})
                    }else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                        this.alertValue = true
                    }
                } 
            }
        },
        async getCategoryItems(){
            try {
                const response = await getCategoryItems(this.hubID,this.categoryId,this.size,this.pageNumber)
                if(response){
                    if(response.status == 200) {
                        this.categoryItems = response.data.data
                        window.scrollTo(0,0)
                        this.categoryItemsInfo = response.data.meta.page
                    }
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                         this.$router.push({name: 'PageNotFound'})
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                        this.alertValue = true
                    }
                }
            }
        },
        async getHubCategories() {
          try {
            const response = await getHubCategories(this.hubID);
            if (response) {
              if (response.status == 200) {
                this.hubCategories = response.data.data;
              }
            }
          } catch (e) {
            if (e.response) {
              if (e.response.status == 404) {
                this.$router.push({ name: "PageNotFound" });
              } else {
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
                this.alertValue = true;
              }
            }
          }
        },
        async getAllCategoryItems() {
          try {
            const response = await getAllCategoryItems(
             this.hubID,this.categoryId,
            );
            if (response) {
              if (response.status == 200) {
                this.allCategoryItems = response.data.data;
                //this.$refs.items.scrollIntoView()
              }
            }
          } catch (e) {
            if (e.response) {
              if (e.response.status == 404) {
                this.$router.push({ name: "PageNotFound" });
              } else {
                this.alertType = "error";
                this.alertMsg = i18n.t("serverError");
                this.alertValue = true;
              }
            }
          }
        },
        async changeCategory(item, categoryId) {
        this.dialogVisibleChangeCategory = false;
        if(item.attributes.category_id != categoryId){
          try {
            let data = {
              data: {
                type: "hub-feed-items",
                id: item.id,
                attributes: {
                  category_id: categoryId,
                },
              },
            };
            const response = await changeHubItemCategory(item.id, data);
            if (response.status == 200) {
              await this.getCategoryItems();

              this.alertType = "success";
              this.alertMsg = i18n.t("hubCategoryChangedSuccess");
              this.alertValue = true;
            }
          } catch (e) {
            if (e.response) {
              this.alertType = "error";
              this.alertMsg = i18n.t("serverError");
              this.alertValue = true;
            }
          }
        }
      },
       async deleteHubAttachment(item) {
      try {
        const response = await deleteHubAttachment(item);
        if (response.status == 204) {
          await this.getCategoryItems();

          this.alertType = "success";
          this.alertMsg = i18n.t("removeAttachmentFromKbSuccessMsg");
          this.alertValue = true;
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
            this.alertValue = true;
          }
        }
      }
    },
    async deleteHubLink(item) {
      try {
        const response = await deleteHubLink(item);
        if (response.status == 204) {
          await this.getCategoryItems();

          this.alertType = "success";
          this.alertMsg = i18n.t("removeLinkFromHubSuccessMsg");
          this.alertValue = true;
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
            this.alertValue = true;
          }
        }
      }
    },
        async deleteHubActivity(activityID) {
      try {
        let data = {
          data: {
            type: "activities",
            attributes: {
              activities_uuid: activityID,
            },
          },
        };

        const response = await deleteHubActivity(this.hubID, data);
        if (response.status == 200) {
          await this.getCategoryItems();

          this.alertType = "success";
          this.alertMsg = i18n.t("removeActivityFromKbSuccessMsg");
          this.alertValue = true;

          //check if auto_share_with_activities is changed on hub level
          const response_hub = await getHub(this.hubID);
          if (
            this.autoShareWithActivities !=
            response_hub.data.data.attributes.auto_share_with_activities
          ) {
            this.autoShareWithActivities =
              response_hub.data.data.attributes.auto_share_with_activities;
            //emit event to notify top bar
            eventBus.$emit(
              "setHubAutoShareWithActivities",
              response_hub.data.data.attributes.auto_share_with_activities
            );
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
            this.alertValue = true;
          }
        }
      }
    },
    async changeActivityAutoSharing(autoShare) {
      this.loadingUpdateAutosharing = true;
      try {
        let data = {
          data: {
            type: "hubs",
            attributes: {
              activity_uuid: this.selectedActivity.attributes.entity_id,
              auto_share: autoShare,
            },
          },
        };
        const response = await updateHubActivityRelationship(this.hubID, data);
        if (response) {
          if (response.status == 200) {
            this.loadingUpdateAutosharing = false;
            this.dialogVisibleChangeActivityAutosharing = false;

            this.alertType = "success";
            this.alertMsg = i18n.t("changeActivityAutosharingSuccess");
            this.alertValue = true;

            await this.getCategoryItems();

            //check if auto_share_with_activities is changed on hub level
            const response_hub = await getHub(this.hubID);
            if (
              this.autoShareWithActivities !=
              response_hub.data.data.attributes.auto_share_with_activities
            ) {
              this.autoShareWithActivities =
                response_hub.data.data.attributes.auto_share_with_activities;
              //emit event to notify top bar
              eventBus.$emit(
                "setHubAutoShareWithActivities",
                response_hub.data.data.attributes.auto_share_with_activities
              );
            }
          }
        }
      } catch (e) {
        if (e.response) {
          this.loadingUpdateAutosharing = false;
          this.dialogVisibleChangeActivityAutosharing = false;
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
          this.alertValue = true;
        }
      }
    },
    closeSearch(){
      this.search = null
      this.searchKeyword = null
      this.$nextTick(() => {
            this.searchClosed = true
        })
    },
    showMore() {
      this.readMore = true;
    },
    showLess() {
      this.readMore = false;
    },
          
    }
}

</script>

<style>

</style>